window.Blimp = window.Blimp || {};

class GroupView extends Backbone.View {
  get tagName() {
    return 'div';
  }

  get className() {
    return 'group';
  }

  initialize(options) {
    this.date = options.date;
    this.report_views = [];
    this.listenTo(this.collection, 'add', this.reportWasAdded);
  }

  reportWasAdded(model) {
    const view = new Blimp.ReportView({ model: model });
    this.listenToOnce(view, 'remove', this.reportViewWasRemoved);

    this.report_views.push(view);
    this.report_views = _.sortBy(this.report_views, (v) => v.model.get('taken_at') || v.model.get('created_at'));
    const index = _.indexOf(this.report_views, view);

    if (index > 0) {
      this.report_views[index - 1].$el.before(view.render().el);
    } else {
      this.$el.append(view.render().el);
    }
  }

  reportViewWasRemoved(view) {
    this.report_views = _.without(this.report_views, view);
    if (this.report_views.length < 1) {
      this.trigger('remove', this);
      this.remove();
    }
  }

  render() {
    this.$el.html(`<h1>${this.date.format('dddd, YYYY-MM-DD')}</h1>`);
    return this;
  }
}

Blimp.GroupView = GroupView;